export const ImageFilters = {
  white: {
    filter:
      "brightness(0) saturate(100%) invert(97%) sepia(3%) saturate(2%) hue-rotate(214deg) brightness(117%) contrast(100%)",
  },
  black: {
    filter: "brightness(0)",
  },
  blue: {
    filter:
      "brightness(0) saturate(100%) invert(11%) sepia(83%) saturate(4588%) hue-rotate(199deg) brightness(93%) contrast(101%)",
  },
  uspCardOne: {
    filter:
      "brightness(0) saturate(100%) invert(11%) sepia(83%) saturate(4588%) hue-rotate(199deg) brightness(93%) contrast(101%)",
  },
  uspCardTwo: {
    filter:
      "brightness(0) saturate(100%) invert(64%) sepia(59%) saturate(3190%) hue-rotate(346deg) brightness(98%) contrast(96%)",
  },
  uspCardThree: {
    filter:
      "brightness(0) saturate(100%) invert(18%) sepia(100%) saturate(3361%) hue-rotate(269deg) brightness(83%) contrast(108%)",
  },
  uspCardFour: {
    filter:
      "brightness(0) saturate(100%) invert(25%) sepia(91%) saturate(1805%) hue-rotate(127deg) brightness(87%) contrast(101%)",
  },
};

export const StudentRegistrationType = {
  student: "Student",
  coordinator: "Coordinator",
}
export const OtpVerificationType = {
  login: "login",
  forgotPassword: "forgot-password",
};

export const ConfirmationModalTheme = {
  warning: {
    primary: "#FEBE5D",
    secondary: "#FFF0D9",
    tertiary: "#FFF5E5"
  },
  error: {
    primary: "#FF3535",
    secondary: "#FFDBDB",
    tertiary: "#FFE5E5"
  }, 
  theme: {
    primary: "#14489F",
    secondary: "#C6DBFF",
    tertiary: "#DFEBFF"
  },
  success: {
    primary: "#3EC13E",
    secondary: "#DFFFDF",
    tertiary: "#E9FFE9"
  }
}

